import { ReportTypes } from "../../constants/report-types.enum";

export enum TravelHistoryMessages {

  // region Travel History
  time = "travelHistory.time",
  distance = "travelHistory.distance",
  durationInMinutes = "travelHistory.durationInMinutes",
  distanceInKilometers = "travelHistory.distanceInKilometers",
  document = "travelHistory.document",
  origin = "travelHistory.origin",
  destination = "travelHistory.destination",
  finishPoint = "travelHistory.finishPoint",
  travelHistoryTitle = "travelHistory.travelHistoryTitle",
  travels = "travelHistory.historyTitle",
  pumpReportTitle = "travelHistory.pumpReportTitle",
  coordinatesTitle = "travelHistory.coordinatesTitle",
  on = "travelHistory.on",
  off = "travelHistory.off",
  occurrenceDate = "travelHistory.occurrenceDate",
  status = "travelHistory.status",
  ignition = "travelHistory.ignition",
  speed = "travelHistory.speed",
  latitude = "travelHistory.latitude",
  longitude = "travelHistory.longitude",
  address = "travelHistory.address",
  average = "travelHistory.average",
  movingAverage = "travelHistory.movingAverage",
  records = "travelHistory.records",
  averageSpeed = "travelHistory.averageSpeed",
  registrationDate = "travelHistory.registrationDate",
  intervalBetweenLastCommand = "travelHistory.intervalBetweenLastCommand",
  analyticReport = "travelHistory.analyticReport",
  syntheticReport = "travelHistory.syntheticReport",
  vehiclePlate = "travelHistory.vehiclePlate",
  vehicleType = "travelHistory.vehicleType",
  plant = "travelHistory.plant",
  travelPlant = "travelHistory.travelPlant",
  regional = "travelHistory.regional",
  group = "travelHistory.group",
  addressNotFound = "travelHistory.addressNotFound",
  integrationReport = "travelHistory.integrationReport",
  client = "travelHistory.client",
  constructionEntryDate = "travelHistory.constructionEntryDate",
  constructionLeaveDate = "travelHistory.constructionLeaveDate",
  durationOnConstruction = "travelHistory.durationOnConstruction",
  totalPumpingDuration = "travelHistory.totalPumpingDuration",
  totalIdleDuration = "travelHistory.totalIdleDuration",
  mixerVehicleCode = "travelHistory.mixerVehicleCode",
  noMixerRelated = "travelHistory.noMixerRelated",
  documentNumber = "travelHistory.documentNumber",
  startDateTransport = "travelHistory.startDateTransport",
  endDateTransport = "travelHistory.endDateTransport",
  durationTransport = "travelHistory.durationTransport",
  startDateLocation = "travelHistory.startDateLocation",
  endDateLocation = "travelHistory.endDateLocation",
  durationLocation = "travelHistory.durationLocation",
  startDateUnload = "travelHistory.startDateUnload",
  endDateUnload = "travelHistory.endDateUnload",
  durationUnload = "travelHistory.durationUnload",
  startDateReturn = "travelHistory.startDateReturn",
  endDateReturn = "travelHistory.endDateReturn",
  durationReturn = "travelHistory.durationReturn",
  // endregion Travel History
  // region Integration Report
  integrationReport_column_numNf = "travelHistory.integrationReport.column.numNf",
  integrationReport_column_statusNf = "travelHistory.integrationReport.column.statusNf",
  integrationReport_column_emissionType = "travelHistory.integrationReport.column.emissionType",
  integrationReport_column_emission = "travelHistory.integrationReport.column.emission",
  integrationReport_column_integration = "travelHistory.integrationReport.column.integration",
  integrationReport_column_loadGroup = "travelHistory.integrationReport.column.loadGroup",
  integrationReport_column_vehicle = "travelHistory.integrationReport.column.vehicle",
  integrationReport_column_driverCode = "travelHistory.integrationReport.column.driverCode",
  integrationReport_column_driverDocument = "travelHistory.integrationReport.column.driverDocument",
  integrationReport_column_origin = "travelHistory.integrationReport.column.origin",
  integrationReport_column_destination = "travelHistory.integrationReport.column.destination",
  integrationReport_column_client = "travelHistory.integrationReport.column.client",
  integrationReport_column_productType = "travelHistory.integrationReport.column.productType",
  integrationReport_column_errorCode = "travelHistory.integrationReport.column.errorCode",
  integrationReport_loadGroupModalTitle = "travelHistory.integrationReport.loadGroupModalTitle",
  // endregion Integration Report
}

export type TranslationTravelHistoryMessages = {
  [key in TravelHistoryMessages]: string;
}

export const ReportTypesMessages = {
  [ReportTypes.ANALYTIC]: TravelHistoryMessages.analyticReport,
  [ReportTypes.SYNTHETIC]: TravelHistoryMessages.syntheticReport
};
